import * as THREE from 'three';
import { LineIntersType, RoomType } from '../../../types';
import BasicObject from '../../BasicObject';
import { DrainLineObject } from '../DrainLineObject';
import { LineLinkPoint } from './LineLinkPoint';
import { CircleCrossMove } from './CircleCrossMove';

interface PlanePropsType {
  position: THREE.Vector3;
  planeIntersected: RoomType;
  moveObject: CircleCrossMove;
  lineMove: LineLinkPoint;
  lineSideUpdate: keyof LineIntersType;
}
export class PlaneMove extends BasicObject {
  static Sensitive = 0.1;
  private ray = new THREE.Raycaster();
  private pointMagnet = new THREE.Vector3();
  private directRay = new THREE.Vector3(0, 1, 0);
  private startPosition = new THREE.Vector3();
  private moveObject: CircleCrossMove;
  private readonly lineSideUpdate: keyof LineIntersType;
  material = new THREE.MeshBasicMaterial({ color: '#ff00ff', transparent: true, opacity: 0 });
  lineMove: LineLinkPoint;
  planeIntersected: RoomType;

  constructor({
    position,
    moveObject,
    planeIntersected,
    lineMove,
    lineSideUpdate,
  }: PlanePropsType) {
    super();
    this.name = 'point_funnel_move';
    this.position.copy(position);
    this.moveObject = moveObject;
    this.planeIntersected = planeIntersected;
    this.lineMove = lineMove;
    this.lineSideUpdate = lineSideUpdate;

    this.buildGeometry();
  }
  buildGeometry() {
    super.buildGeometry();
    this.geometry = new THREE.PlaneGeometry(DrainLineObject.SizePlane, DrainLineObject.SizePlane);
    this.geometry.applyMatrix4(new THREE.Matrix4().makeRotationX(-Math.PI / 2));
  }
  dragStart() {
    this.startPosition.copy(this.position);
    if (this.lineSideUpdate === 'start') {
      this.pointMagnet.copy(this.lineMove.end);
    } else {
      this.pointMagnet.copy(this.lineMove.start);
    }
  }
  drag() {
    const pointMagnetX = this.position.clone().setX(this.pointMagnet.x);
    const pointMagnetZ = this.position.clone().setZ(this.pointMagnet.z);
    if (pointMagnetX.distanceTo(this.position) < PlaneMove.Sensitive) {
      this.position.copy(pointMagnetX);
    }
    if (pointMagnetZ.distanceTo(this.position) < PlaneMove.Sensitive) {
      this.position.copy(pointMagnetZ);
    }

    this.ray.set(this.position.clone().setY(-0.02), this.directRay);
    const inters = this.ray.intersectObject(this.planeIntersected);
    if (inters.length > 0) {
      this.startPosition.copy(this.position);
    } else {
      this.position.copy(this.startPosition);
    }

    this.lineMove.updateLineGeometry(this.position, this.lineSideUpdate);
    this.moveObject.position.copy(this.position);
  }
  dragEnd() {
    if (this.planeIntersected.drainFunnelLine) {
      this.planeIntersected.drainFunnelLine[this.lineSideUpdate].copy(this.position);
    }
  }
  removeMesh() {
    super.removeMesh(this);
  }
}
